// extracted by mini-css-extract-plugin
export default {"User":"styles_User__oIGRg","allMembers":"styles_allMembers__Z7nGU","noPhoto":"styles_noPhoto__mhLEs"};